import React from 'react';
type IconProps = {
  className?: string;
  strokeWidth?: number;
};
/**
 * Custom hand-drawn SVG icon set for the GastroSmart sales page.
 * No emojis anywhere — every glyph is a bespoke stroked icon that
 * matches the healing / anti-fire theme of the product.
 */
export function FlameIcon({
  className = 'w-6 h-6',
  strokeWidth = 2
}: IconProps) {
  return <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true" data-id="element-221" data-mp="15yjrw8oa2nuc">
      <path d="M12 2.5c.6 3 3.2 4.3 3.2 7.4 0 .9-.3 1.7-.8 2.3.9-.2 1.7-.9 2.1-1.9 1.4 1.6 2.2 3.4 2.2 5.1a6.9 6.9 0 1 1-13.8 0c0-2.6 1.6-4.8 3-6.6.4 1 .1 2.4-.3 3.3C10 12.9 12 10.4 12 7c0-1.6-.4-3.1-.8-4.5.4.3.8.6 1.6 0Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinejoin="round" strokeLinecap="round" data-id="element-222" data-mp="1xnv8nf8dl1hn" />
    </svg>;
}
export function ShieldHeartIcon({
  className = 'w-6 h-6',
  strokeWidth = 2
}: IconProps) {
  return <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true" data-id="element-223" data-mp="2hdoxbkfsn0hn">
      <path d="M12 2.5 4.5 5.2v6c0 4.4 3.1 8.2 7.5 10.3 4.4-2.1 7.5-5.9 7.5-10.3v-6L12 2.5Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinejoin="round" data-id="element-224" data-mp="tdrtocqme8sn" />
      <path d="M12 15.4c-1.5-1.1-3.3-2.4-3.3-4.1 0-1 .8-1.7 1.7-1.7.7 0 1.2.4 1.6.9.4-.5.9-.9 1.6-.9.9 0 1.7.7 1.7 1.7 0 1.7-1.8 3-3.3 4.1Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinejoin="round" data-id="element-225" data-mp="12epy2w4z0ibr" />
    </svg>;
}
export function LeafIcon({
  className = 'w-6 h-6',
  strokeWidth = 2
}: IconProps) {
  return <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true" data-id="element-226" data-mp="1q394150jsj0o">
      <path d="M5 19c0-8 5.5-13 15-13 0 9.5-5 15-13 15-.7 0-1.4-.1-2-.2Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinejoin="round" data-id="element-227" data-mp="1l34nxg3jxqaz" />
      <path d="M5 19c2.5-4.5 6-7.5 11-9.5" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" data-id="element-228" data-mp="3my5942lyeo3t" />
    </svg>;
}
export function CheckIcon({
  className = 'w-6 h-6',
  strokeWidth = 2.4
}: IconProps) {
  return <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true" data-id="element-229" data-mp="20qajpap8sf7k">
      <path d="M4.5 12.5 9.5 17.5 19.5 6.5" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" data-id="element-230" data-mp="24uidhmak4lcn" />
    </svg>;
}
export function CrossIcon({
  className = 'w-6 h-6',
  strokeWidth = 2.4
}: IconProps) {
  return <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true" data-id="element-231" data-mp="2jid7r747qxru">
      <path d="M6 6 18 18M18 6 6 18" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" data-id="element-232" data-mp="2og4vdoxtrxq8" />
    </svg>;
}
export function ClockIcon({
  className = 'w-6 h-6',
  strokeWidth = 2
}: IconProps) {
  return <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true" data-id="element-233" data-mp="luj1ejwu6cyq">
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth={strokeWidth} data-id="element-234" data-mp="guemuzfhnsb5" />
      <path d="M12 7.5V12l3 2" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" data-id="element-235" data-mp="cvp0wigdx2fw" />
    </svg>;
}
export function LockIcon({
  className = 'w-6 h-6',
  strokeWidth = 2
}: IconProps) {
  return <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true" data-id="element-236" data-mp="10jysk10a4key">
      <rect x="4.5" y="10.5" width="15" height="10" rx="2.2" stroke="currentColor" strokeWidth={strokeWidth} data-id="element-237" data-mp="vqcblwn31udc" />
      <path d="M8 10.5V8a4 4 0 0 1 8 0v2.5" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" data-id="element-238" data-mp="1o9jacgkp5bmn" />
      <circle cx="12" cy="15.3" r="1.4" fill="currentColor" data-id="element-239" data-mp="132s3m6wjeun7" />
    </svg>;
}
export function DropletIcon({
  className = 'w-6 h-6',
  strokeWidth = 2
}: IconProps) {
  return <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true" data-id="element-240" data-mp="17z8tp6narj2x">
      <path d="M12 3.5c3.2 4 6 7 6 10.2A6 6 0 0 1 6 13.7C6 10.5 8.8 7.5 12 3.5Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinejoin="round" data-id="element-241" data-mp="z0x7dgtgr7ga" />
      <path d="M9 14.5a3 3 0 0 0 2.4 2.4" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" data-id="element-242" data-mp="1qs3a850kjj99" />
    </svg>;
}
export function StarIcon({
  className = 'w-5 h-5'
}: IconProps) {
  return <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true" data-id="element-243" data-mp="1hyrc3ink6wsv">
      <path d="M12 2.5l2.9 5.9 6.5.9-4.7 4.6 1.1 6.5L12 17.9 6.2 20.9l1.1-6.5L2.6 9.8l6.5-.9L12 2.5Z" data-id="element-244" data-mp="25nsqdmj2p262" />
    </svg>;
}
export function QuoteIcon({
  className = 'w-8 h-8'
}: IconProps) {
  return <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true" data-id="element-245" data-mp="2jtch0nzqtp48">
      <path d="M9.5 6C6.5 7 5 9.4 5 13v5h5v-5H7.7c.1-2.1 1-3.4 2.8-4L9.5 6Zm9 0c-3 1-4.5 3.4-4.5 7v5h5v-5h-2.3c.1-2.1 1-3.4 2.8-4L18.5 6Z" data-id="element-246" data-mp="2fr7ppvwrp4kr" />
    </svg>;
}
export function CartIcon({
  className = 'w-6 h-6',
  strokeWidth = 2
}: IconProps) {
  return <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true" data-id="element-247" data-mp="20x2vjfmihwa7">
      <path d="M3 4h2l2.2 11.2a1.5 1.5 0 0 0 1.5 1.2h8.1a1.5 1.5 0 0 0 1.5-1.2L20 7H6" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" data-id="element-248" data-mp="1wvrdbv5ywdc1" />
      <circle cx="9.5" cy="20" r="1.4" fill="currentColor" data-id="element-249" data-mp="25x7dla32iz2j" />
      <circle cx="17.5" cy="20" r="1.4" fill="currentColor" data-id="element-250" data-mp="3m8be0saf3rz8" />
    </svg>;
}
export function ArrowRightIcon({
  className = 'w-6 h-6',
  strokeWidth = 2.2
}: IconProps) {
  return <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true" data-id="element-251" data-mp="3pbinb5x5rukh">
      <path d="M4 12h15M13 6l6 6-6 6" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" data-id="element-252" data-mp="3tbj9xduevc2m" />
    </svg>;
}
export function SparkIcon({
  className = 'w-6 h-6',
  strokeWidth = 2
}: IconProps) {
  return <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true" data-id="element-253" data-mp="35nrnhhf5pinm">
      <path d="M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5 18 18M18 6l-2.5 2.5M8.5 15.5 6 18" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" data-id="element-254" data-mp="3amusj1v4zovl" />
    </svg>;
}